export const PROPERTY_VALUE_CHANGE = 'PROPERTY_VALUE_CHANGE';
export const PROPERTY_VALIDATION_CHANGE = 'PROPERTY_VALIDATION_CHANGE';
export const RESET_PROPERTY_VALUE = 'RESET_PROPERTY_VALUE';
export const RESET_ALL = 'RESET_ALL';
export const HOVER_DATE_TIME_CELL = 'HOVER_DATE_TIME_CELL';